<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="600"
  >
    <v-card>
      <v-toolbar
        dark
      >
        <v-toolbar-title>
          Create New Target
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-select
          v-model="package"
          :items="packages"
          label="select package"
          outlined
        ></v-select>
        <v-text-field
          v-model="targetName"
          outlined
          label="Target Name"
        ></v-text-field>
        <v-text-field
          v-model="targetId"
          outlined
          label="Target ID"
          type="number"
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="#f5f5f5" :disabled="!canCreate()" @click="onCreateClick()">Create</v-btn>
        <v-btn color="grey lighten-1" @click="onCancelClick()">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: Boolean,
  },

  data() {
    return {
      package: '',
      targetName: '',
      targetId: 0,

      packages: [
        'Included',
        'Limited',
        'Premium + VAG',
      ],
      packageLookup: {
        Included: 0,
        Limited: 1,
        'Premium + VAG': 4,
      },
    };
  },

  methods: {
    canCreate() {
      return (this.package !== '' && this.targetName !== '' && parseInt(this.targetId) >= 0);
    },

    onCreateClick() {
      const p = this.packageLookup[this.package];

      this.$emit('close', {
        packageName: this.package,
        packageIndex: p,
        targetName: this.targetName,
        targetId: parseInt(this.targetId, 10),
      });

      this.package = '';
      this.targetName = '';
      this.targetId = '';
    },

    onCancelClick() {
      this.$emit('close', { });

      this.package = '';
      this.targetName = '';
      this.targetId = '';
    },
  },
};
</script>
